export default "__VITE_ASSET__ChX1tVGh__"